// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import {
  CognitoIdentityProviderClient,
  InitiateAuthCommand,
  SignUpCommand,
  ConfirmSignUpCommand,
  GetUserCommand,
  type InitiateAuthCommandInput,
  type SignUpCommandInput,
  type ConfirmSignUpCommandInput,
} from "@aws-sdk/client-cognito-identity-provider";
import config from "./config.json";
import { BehaviorSubject } from "rxjs";

export const cognitoSubject$ = new BehaviorSubject(false);

export const cognitoClient = new CognitoIdentityProviderClient({
  region: config.region,
});

export const getUser = async (accessToken: string) => {
  const input = {
    // GetUserRequest
    AccessToken: accessToken, // required
  };
  const command = new GetUserCommand(input);
  const response = await cognitoClient.send(command);
  // { // GetUserResponse
  //   Username: "STRING_VALUE", // required
  //   UserAttributes: [ // AttributeListType // required
  //     { // AttributeType
  //       Name: "STRING_VALUE", // required
  //       Value: "STRING_VALUE",
  //     },
  //   ],
  //   MFAOptions: [ // MFAOptionListType
  //     { // MFAOptionType
  //       DeliveryMedium: "SMS" || "EMAIL",
  //       AttributeName: "STRING_VALUE",
  //     },
  //   ],
  //   PreferredMfaSetting: "STRING_VALUE",
  //   UserMFASettingList: [ // UserMFASettingListType
  //     "STRING_VALUE",
  //   ],
  // };
  return response;
};

export const signIn = async (username: string, password: string) => {
  const params: InitiateAuthCommandInput = {
    AuthFlow: "USER_PASSWORD_AUTH",
    ClientId: config.clientId,
    AuthParameters: {
      USERNAME: username,
      PASSWORD: password,
    },
  };
  try {
    const command = new InitiateAuthCommand(params);
    const { AuthenticationResult } = await cognitoClient.send(command);
    if (AuthenticationResult) {
      localStorage.setItem("idToken", AuthenticationResult.IdToken || "");
      localStorage.setItem(
        "accessToken",
        AuthenticationResult.AccessToken || "",
      );
      localStorage.setItem(
        "refreshToken",
        AuthenticationResult.RefreshToken || "",
      );
      return AuthenticationResult;
    }
  } catch (error) {
    console.error("Error signing in: ", error);
    throw error;
  }
};

export const signUp = async (email: string, password: string) => {
  const params: SignUpCommandInput = {
    ClientId: config.clientId,
    Username: email,
    Password: password,
    UserAttributes: [
      {
        Name: "email",
        Value: email,
      },
    ],
  };
  try {
    const command = new SignUpCommand(params);
    const response = await cognitoClient.send(command);
    console.log("Sign up success: ", response);
    return response;
  } catch (error) {
    console.error("Error signing up: ", error);
    throw error;
  }
};

export const confirmSignUp = async (username: string, code: string) => {
  const params: ConfirmSignUpCommandInput = {
    ClientId: config.clientId,
    Username: username,
    ConfirmationCode: code,
  };
  try {
    const command = new ConfirmSignUpCommand(params);
    await cognitoClient.send(command);
    console.log("User confirmed successfully");
    return true;
  } catch (error) {
    console.error("Error confirming sign up: ", error);
    throw error;
  }
};
